// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1iRpZ","empty":"ModalGraph_empty__2597O"};